import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";
import { isString } from 'lodash';

const toastError = err => {
	// Backends can return different shapes:
	// - { error: "ERR_..." }
	// - { detail: "..." }
	// - { detail: { error: "...", message: "..." } }
	const data = err?.response?.data;
	const detail = data?.detail;

	const errorCode =
		data?.error ||
		(detail && typeof detail === "object" ? detail.error : undefined);

	const message =
		data?.message ||
		(isString(detail) ? detail : undefined) ||
		(detail && typeof detail === "object" && isString(detail.message) ? detail.message : undefined);

	if (errorCode) {
		const key = `backendErrors.${errorCode}`;
		const translated = i18n?.exists?.(key) ? i18n.t(key) : null;
		const text = translated || message || String(errorCode);

		toast.error(text, {
			toastId: errorCode,
			autoClose: 2000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: false,
			draggable: true,
			progress: undefined,
			theme: "light",
		});
		return;
	}

	if (isString(message)) {
		toast.error(message);
		return;
	}

	if (isString(err)) {
		toast.error(err);
		return;
	}

	toast.error(i18n?.t?.("common.anErrorOccurred") || "An error occurred!");
	return;
};

export default toastError;
